import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=b040cde6&scoped=true"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=ts"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=ts"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&id=b040cde6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b040cde6",
  null
  
)

export default component.exports